module.exports = __webpack_public_path__ + "img/xnr2.d7833fd4.png";